import type from './location.types'
import * as utils from './location.utils'

export const initialState = {
  currentLocation: null,
  list: {
    data: [],
    header: [],
    body: [],
    limit: 50,
    page: 1,
    total: 1,
  },
  errors: {
    current: {},
    data: [],
  },
  isLoading: null,
}

const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.LOCATION_TRY:
      return {
        ...state,
        isLoading: true,
      }

    case type.SET_CURRENT_LOCATION:
      return {
        ...state,
        currentLocation: action.payload,
        isLoading: false,
      }

    case type.LIST_SUCCESS:
      const list = utils.formatData(action.payload)
      return { ...state, isLoading: false, list }

    case type.ADD_LOCATION: {
      const data = [...state.list.data, action.payload.data]
      const list = utils.formatData({ data })

      return {
        ...state,
        isLoading: false,
        list,
      }
    }

    case type.UPDATE_LOCATION: {
      const index = state.list.data.findIndex(
        location => location.id === Number(action.payload.id)
      )

      if (index !== -1) {
        state.list.data[index] = {
          ...action.payload.data,
          id: Number(action.payload.id),
        }

        const list = utils.formatData({ data: state.list.data })
        return { ...state, list, isLoading: false }
      }

      return state
    }

    case type.DELETE_LOCATION: {
      const id = Number(action.payload)
      const data = state.list.data.filter(source => source.id !== id)
      const body = state.list.body.filter(source => source.id !== id)
      if (data) {
        return {
          ...state,
          isLoading: false,
          list: {
            ...state.list,
            data,
            body,
          },
        }
      }
      return state
    }

    case type.LOCATION_FAILED:
      const errors = utils.addError(state.errors, action)
      return { ...state, errors: { ...errors }, isLoading: false }

    case type.CLEAR_CURRENT_ERROR_LOCATION: {
      return {
        ...state,
        errors: {
          ...state.errors,
          current: {},
        },
        isLoading: false,
      }
    }

    default:
      return state
  }
}

export default locationReducer
